import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useLanguage } from './LanguageContext';
import './DisclosureCard.css';

const DisclosureCard = ({
  title,
  subtitle,
  defaultOpen = false,
  alwaysOpen = false,
  className = '',
  children,
}) => {
  const { tt } = useLanguage();
  const [open, setOpen] = useState(defaultOpen);
  const isOpen = alwaysOpen || open;

  return (
    <section className={`disclosure-card ${className}`.trim()}>
      <header className="disclosure-head">
        <div>
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {!alwaysOpen && (
          <button
            type="button"
            className="disclosure-toggle"
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
          >
            <span>{open ? tt('Hide details') : tt('Show details')}</span>
            {open ? <FiChevronUp size={15} /> : <FiChevronDown size={15} />}
          </button>
        )}
      </header>

      {isOpen && <div className="disclosure-body">{children}</div>}
    </section>
  );
};

export default DisclosureCard;
